import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import App from './App.vue';
import router from './router';
import { enableMocking } from './mock/browser';

import './styles/global.css';

async function bootstrap() {
  // Start MSW mock service only if explicitly enabled
  if (import.meta.env.VITE_ENABLE_MOCK === 'true') {
    await enableMocking();
  }

  const app = createApp(App);

  // Register all Element Plus Icons
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }

  const pinia = createPinia();
  app.use(pinia);
  app.use(router);
  app.use(ElementPlus);

  app.mount('#app');
}

bootstrap();
